import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface LabUsersState {
    list: string[][],
  }
  
const initialState:LabUsersState = {
    list:[],
}

export const LabUsersSlice = createSlice({
    name:"labUsers",
    initialState,
    reducers:{
        UpdateLabUsers: (state,action) => {
            state.list = action.payload.labUsers;
        },
        AddUser: (state,action) => {
            state.list = [];
        },
        EditUser: (state,action) => {
            state.list = [];
        },
        RemoveUser: (state,action) => {
            state.list = [];
        }
    }
})

export const {UpdateLabUsers,AddUser,EditUser,RemoveUser} = LabUsersSlice.actions

export const selectLabUsers = (state: RootState) => state.labUsers

export default LabUsersSlice.reducer;